import React, { useState } from "react";
import PropTypes from "prop-types";
import { Menu, MenuItem, MenuButton } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import { colors } from "../../../../utils";

export default function MultiSelect({
  options,
  selectedValues,
  onChange,
  children,
  align = "end",
  direction = "bottom",
  offsetX = 0,
  offsetY = 10,
  menuStyle = {},
  portal = true,
  menuButtonProps = {},
  menuProps = {},
}) {
  const handleSelect = (value) => {
    const newSelected = selectedValues.includes(value)
      ? selectedValues.filter((item) => item !== value)
      : [...selectedValues, value];

    onChange(newSelected);
  };

  return (
    <div>
      <Menu
        {...menuProps} // ✅ Allows passing additional menu props
        align={align}
        direction={direction}
        offsetX={offsetX}
        offsetY={offsetY}
        portal={portal}
        gap={10}
        menuButton={
          <MenuButton
            style={{ background: "transparent", border: "none" }}
            {...menuButtonProps}
          >
            {children}
          </MenuButton>
        }
        menuStyle={{
          border: "1px solid #ddd",
          borderRadius: "8px",
          background: "white",
          padding: "10px",
          ...menuStyle, // ✅ Allows overriding styles via props
        }}
      >
        {options.map(({ value, label }) => (
          <MenuItem
            key={value}
            onClick={(e) => {
              e.stopPropagation = true;
              e.keepOpen = true; // ✅ Prevents menu from closing on select
              handleSelect(value);
            }}
            style={{
              gap: "8px",
              paddingLeft: "8px",
              marginBottom: "8px",
              backgroundColor: selectedValues.includes(value)
                ? colors.PrimaryPurple100
                : "white",
              fontSize: "14px",
              fontFamily: "DM Sans, sans-serif",
              fontWeight: "400",
              color: colors.textBlue,
              cursor: "pointer",
            }}
          >
            <input
              type="checkbox"
              checked={selectedValues.includes(value)}
              onChange={() => handleSelect(value)}
              style={{
                accentColor: colors.PrimaryPurple500,
                cursor: "pointer",
              }}
            />
            {label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

// ✅ Define PropTypes
MultiSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  align: PropTypes.oneOf(["start", "center", "end"]),
  direction: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
  menuStyle: PropTypes.object,
  portal: PropTypes.bool,
  menuButtonProps: PropTypes.object,
  menuProps: PropTypes.object,
};

// ✅ Default Props
MultiSelect.defaultProps = {
  align: "end",
  direction: "bottom",
  offsetX: 0,
  offsetY: 10,
  menuStyle: {},
  portal: true,
  menuButtonProps: {},
  menuProps: {},
};
